// extracted by mini-css-extract-plugin
export default {"buttons":"BarChart_buttons__8F86f","button":"BarChart_button__eG5yM"};